export default "__VITE_ASSET__BtLj2Dhv__"